import { useCallback, useEffect, useState } from "react";
import { FileText, Loader2, Trash2 } from "lucide-react";
import { api } from "@/api";
import { toast } from "@/lib/toast";
import { Btn, Empty, Pill, errMsg, money } from "../../comptabilite/_shared";

export default function BankStatements({ base, accountId, changed }) {
  const [items, setItems] = useState(null);
  const load = useCallback(async () => {
    try { const r = await api.get(`${base}/bank/statements`, { params: { account_id: accountId } }); setItems(r.data.items || []); }
    catch (e) { toast.error(errMsg(e)); setItems([]); }
  }, [base, accountId]);
  useEffect(() => { load(); }, [load]);

  const remove = async (s) => {
    if (!window.confirm(`Supprimer le relevé « ${s.filename} » (${s.count} lignes) ? Les écritures déjà créées restent au grand livre ; les lignes du relevé et leurs correspondances sont retirées.`)) return;
    try { const r = await api.delete(`${base}/bank/statements/${s.id}`); toast.success(`${r.data.deleted_lines} ligne(s) retirée(s)`); load(); changed(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  if (items === null) return <div className="p-10 text-center text-slate-400"><Loader2 className="w-6 h-6 animate-spin mx-auto" /></div>;
  return (
    <div className="bg-white border rounded-xl overflow-hidden" data-testid="bank-statements">
      {items.length === 0 ? <Empty icon={FileText} text="Aucun relevé importé pour ce compte." testId="bank-statements-empty" /> : (
        <table className="w-full text-sm" data-testid="bank-statements-table">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
            <tr><th className="text-left px-3 py-2">Importé le</th><th className="text-left px-2 py-2">Fichier</th><th className="text-left px-2 py-2">Format</th><th className="text-left px-2 py-2">Période</th><th className="text-right px-2 py-2">Lignes</th><th className="text-right px-2 py-2 hidden md:table-cell">Doublons</th><th className="text-right px-2 py-2 hidden md:table-cell">Solde de clôture</th><th className="px-2 py-2 w-12"></th></tr>
          </thead>
          <tbody className="divide-y">
            {items.map((s) => (
              <tr key={s.id} className="hover:bg-slate-50" data-testid={`bank-statement-${s.id}`}>
                <td className="px-3 py-2 whitespace-nowrap text-slate-700">{s.imported_at?.slice(0, 16).replace("T", " ")}</td>
                <td className="px-2 py-2 text-slate-800 truncate max-w-[260px]" title={s.filename}>{s.filename}</td>
                <td className="px-2 py-2"><Pill>{s.format === "ofx" ? "OFX" : s.preset === "desjardins" ? "CSV Desjardins" : "CSV"}</Pill></td>
                <td className="px-2 py-2 whitespace-nowrap text-xs text-slate-600">{s.date_from} → {s.date_to}</td>
                <td className="px-2 py-2 text-right font-mono">{s.count}</td>
                <td className="px-2 py-2 text-right font-mono text-slate-400 hidden md:table-cell">{s.duplicates}</td>
                <td className="px-2 py-2 text-right font-mono hidden md:table-cell">{s.closing_balance == null ? "—" : money(s.closing_balance)}</td>
                <td className="px-2 py-2 text-right"><Btn tone="ghost" icon={Trash2} onClick={() => remove(s)} testId={`bank-statement-delete-${s.id}`} title="Supprimer ce relevé" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
